import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
};
const getters = {
};

const actions = {
    [actionType.USER_POST_CONTACT_IN_FAQ]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.post('/contact', params).then(result => {
                if(result.data.data) {
                    resolve(result.data.data)
                }
            })
            .catch(error => reject(error));
        });
    }
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}